import { createTheme } from "@mui/material/styles";

export const DynamicMuiTheme = (colorPrimary, colorSecondary) => {
  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  return createTheme({
    palette: {
      colorPrimer: createColor(colorPrimary ?? "#000080"),
      colorSecondary: createColor(colorSecondary ?? "#ffff00"),
      primary: createColor(colorSecondary ?? "#0000ff"),
    },
  });
};
